import type { FuseSearchResult } from '@talos/kyoko';
import { IGNORED_AUTOCOMPLETE_GROUP } from '@talos/kyoko/src/components/Form/Autocomplete/tokens';

export const ITEM_HEIGHT = 32;

export const GROUP_DEFAULT_AGGREGATION = 'Default Aggregation';
export const GROUP_AGGREGATIONS = 'Aggregations';

export type PresetRowEntry =
  | { rowKey: string; kind: 'custom'; presetId: string }
  | { rowKey: string; kind: 'aggregation'; presetId: string; placement: 'defaultPin' | 'list' };

/** Same preset id + row kind (e.g. default pin vs list duplicate) — treat as one logical selection for aria/highlight. */
export function presetRowEntriesRepresentSameSelection(a: PresetRowEntry, b: PresetRowEntry): boolean {
  return a.kind === b.kind && a.presetId === b.presetId;
}

/** Fuse-shaped result for the pinned default row (outside virtualized AutocompleteResults). */
export function createSyntheticPresetSearchResult(
  entry: PresetRowEntry,
  label: string
): FuseSearchResult<PresetRowEntry> {
  return {
    item: {
      item: entry,
      label,
      description: '',
      disabled: false,
      _group: IGNORED_AUTOCOMPLETE_GROUP,
    },
    refIndex: 0,
    score: 0,
    matches: undefined,
  };
}
